import React, { useRef, useState, useEffect } from "react";
import { Table, Button } from "antd";
import { YhBox } from "@src/components/YhBox";
import { PlusOutlined } from '@ant-design/icons';
import { EditableCell, EditableRow } from "@components/YHEditTable/editTable";
import { momentDateFormat } from '@src/utils/utils'
import { rosterDetailsModels } from "./rosterDetailsModels";
import { useNavModel, RouterParamType } from "@src/model/navModel";
import { useLockFn } from "ahooks";
import { rosterService } from "../../rosterService";
import { globalPrompt } from "@src/components/YhMessage";
import moment from "moment";

export const WorkExperience: React.FC = () => {
  const { getSelectedNavState } = useNavModel();
  const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
  const { id, mode } = detailsInfo;
  const {
    getDetail, getFormInfo, onCancel, guid,
  } = rosterDetailsModels();

  const [workExperience, setWorkExperience] = useState<any[]>([]);
  const initWorkExperience = { id: guid(), companyName: "", startDate: "", endDate: "", position: "", jobDescription: "" };

  useEffect(() => {
    if (mode === "add") {
      setWorkExperience([initWorkExperience]);
    }
    if (mode === "edit") {
      getDetail(id, mode);
      setWorkExperience(getFormInfo(mode)?.userWorkExperiencesList?.map((item: any) => ({
        ...item,
        startDate: item.startDate ? moment(item.startDate, 'YYYY-MM-DD HH:mm:ss') : null,
        endDate: item.endDate ? moment(item.endDate, 'YYYY-MM-DD HH:mm:ss') : null,
        time: [
          item.startDate ? moment(item.startDate, 'YYYY-MM-DD HH:mm:ss') : null,
          item.endDate ? moment(item.endDate, 'YYYY-MM-DD HH:mm:ss') : null,
        ],
      })));
    }
  }, [detailsInfo]);

  const columns = [
    {
      align: "center",
      title: "公司名称",
      width: 50,
      dataIndex: "companyName",
      editable: true,
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "工作起始时间",
      width: 50,
      dataIndex: "time",
      editType: "rangepicker",
      editable: true,
      render: (v: any) => {
        if (Array.isArray(v) && v.length === 2) {
          return `${momentDateFormat(v[0])} ~ ${momentDateFormat(v[1])}`;
        }
        return '';
      }
    },
    {
      align: "center",
      title: "职务名称",
      width: 50,
      dataIndex: "position",
      editable: true,
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "工作内容",
      width: 100,
      dataIndex: "jobDescription",
      editable: true,
      render: (v: any, r: any, i: any) => <span style={{ lineHeight: '28px' }}>{v}</span>,
    },
    {
      align: "center",
      title: "操作",
      width: 50,
      dataIndex: "file",
      render: (t: any, r: any) =>
      (
        <span style={{ fontSize: '14px', color: '#4165E3', cursor: 'pointer' }}
          onClick={() => { setWorkExperience(workExperience.filter(item => item.id !== r.id)); }}
        >删除</span>
      )
    }
  ];

  const newSelectColumns = columns?.map((col: any, index) => {
    return {
      ...col,
      onCell: (record: any, rowIndex: number) => {
        return {
          colIndex: index,
          rowIndex,
          record,
          rules: col.rules,
          options: col.options,
          editType: col.editType,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: (row: any) => {
            const newData = [...workExperience];
            const index = newData.findIndex((item) => row.id === item.id);
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row });
            setWorkExperience(newData);
          }
        };
      },
    };
  });

  const onSave = useLockFn(async () => {
    try {
      const params = {
        "employeeId": id,
        "userWorkExperiencesList": workExperience?.map((item: any) => ({
          ...item,
          startDate: item.time?.[0] ? moment(item.time?.[0]).format("YYYY-MM-DD") : null,
          endDate: item.time?.[1] ? moment(item.time?.[1]).format("YYYY-MM-DD") : null,
        }))
      };
      let ret = await rosterService.workInsert(params);
      if (ret.success) {
        await globalPrompt("message", { type: "success", text: '保存成功!' });
      } else {
        await globalPrompt("message", { type: "error", text: "保存失败!" + ret.retMsg });
      }
    } catch (e) {
      console.log("保存失败!", e);
      await globalPrompt("message", { type: "error", text: "保存失败!" });
    }
  });

  const action = (
    <>
      <Button className="mr-5" type="link" shape="round" onClick={() => onSave()}>保存</Button>
      <Button className="mr-5" type="link" shape="round" onClick={() => onCancel(mode)}>取消</Button>
    </>
  );

  return (
    <YhBox action={action} style={{ overflowY: 'auto', padding: 10, margin: 10 }}>
      <div style={{ padding: 10, fontSize: 18, fontWeight: "bold" }}>工作经历</div>
      <div className="workExperienceTableStyle">
        <Table
          rowKey={(record, index) => record.id}
          components={{ body: { row: EditableRow, cell: EditableCell } }}
          columns={newSelectColumns}
          dataSource={workExperience}
          scroll={{ x: "max-content" }}
          pagination={false}
          footer={() => (
            <span
              style={{ color: 'black', cursor: 'pointer' }}
              onClick={() => {
                const currentCertificate = Array.isArray(workExperience) ? workExperience : [];
                setWorkExperience([...currentCertificate, initWorkExperience]);
              }}
            >
              <PlusOutlined />新增一行
            </span>
          )}
        />
      </div>
    </YhBox>
  );
}